import * as React from 'react';
import { connect } from 'react-redux';
import * as userActions from '../../../../redux/user/actions.user';
import asyncDispatch from '../../../../services/mini/asyncDispatch';
import { useEffect, useState } from 'react';
import { prepareBillingChartData } from './prepareBillingChartData';
import BillingTileHeader from '../BillingTileHeader/BillingTileHeader';
import { ConsumptionChart } from '../../../components/Charts/ConsumptionChart';

export function BillingChart({ getResourceUsage }) {
    const [data, setData] = useState(null);
    useEffect(() => {
        getResourceUsage().then((consumptions) => {
            setData(prepareBillingChartData(consumptions));
        });
    }, [getResourceUsage]);

    return <div className="billinhg-chart billing-rechart">
        <BillingTileHeader>
            Resource consumption
        </BillingTileHeader>
        <ConsumptionChart data={data} />
    </div>;
}


function mapStateToProps({ user }, ownProps) {
    return {
        billingPayments: user.payments,
        balance: user.balance,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getResourceUsage: () => asyncDispatch(userActions.getResourceUsage, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(BillingChart);
